<template>
  <footer class="footer">
    <slot
      name="footer-menu"
      :activeID="activeID"
      :toggleDropdown="toggleDropdown"
    ></slot>
  </footer>
</template>

<script lang="js">
  export default  {
    name: 'lms-footer',
    data() {
      return {
		activeID: null
      }
    },
    methods: {
		toggleDropdown(id) {
		  this.activeID = (this.activeID !== id) ? id : null;
		}
    },
}
</script>
